export default __webpack_public_path__ + "2957c80144a9d23be16809be860b2cb6.svg";